<template>
  <div id="parentregisterstatusreport">
    <div class="container admin-wrap">
      <div class="row header mb-5">
        <div class="col-lg-5">
          <h3 class="text-left mb-3">Parent Register Status Report</h3>
        </div>
        <div class="col-lg-7">
          <button type="button" class="btn btn-primary float-right" style="margin-left: 10px" v-on:click="generateReport()">Generate</button>
        </div>
      </div>
      <div class="pb-5">
        <div class="empty-list_image" v-if="parentListInt.length < 1">
          <strong>{{ startupText }}</strong>
          <img src="../assets/notfound.png" />
        </div>
        <div v-if="parentListInt.length > 0" class="datatable_group ClassAttendanceReportPage">
          <el-button type="primary" round @click="exportExcel()" class="btnExport"><i class="fa fa-file-excel-o" aria-hidden="true"></i> Export</el-button>

          <data-tables :data="parentListInt">
            <el-table-column
              v-for="parentListInfo in parentList"
              :prop="parentListInfo.prop"
              :label="parentListInfo.label"
              :key="parentListInfo.prop"
              sortable="custom"
            >
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import XLSX from 'xlsx'

export default {
  name: 'ParentRegisterStatusReport',
  data() {
    return {
      startupText: 'No Record...',

      parentListInt: [],
      parentList: [
        {
          prop: 'Index_No',
          label: 'Student ID',
        },
        {
          prop: 'Full_Name',
          label: 'First Name',
        },
        {
          prop: 'Middle_name',
          label: 'Middle Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
        {
          prop: 'PAR_Father_Email',
          label: 'Father Email',
        },
        {
          prop: 'FatherRegister',
          label: 'Father Register',
        },
        {
          prop: 'FatherEmailSent',
          label: 'Father Invite Email Send',
        },
        {
          prop: 'PAR_Mother_Email',
          label: 'Mother Email',
        },
        {
          prop: 'MotherRegister',
          label: 'Mother Register',
        },
        {
          prop: 'MotherEmailSent',
          label: 'Mother Invite Email Send',
        },
        {},
      ],
    }
  },
  async created() {},
  async mounted() {},
  methods: {
    async generateReport() {
      try {
        this.$vs.loading()

        const response = await DataSource.shared.getParentRegisterStatusReport()

        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Get Parent Register Status Report Error!',
            })
          } else if (response.code === '2') {
            this.$notify({
              title: 'No Record',
              message: 'No Record Found...',
            })
          } else {
            this.parentListInt = response.Table
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    exportExcel() {
      if (this.parentListInt.length > 0) {
        let dsFinal = []

        this.parentListInt.forEach(m => {
          let temp = {
            'Student ID': m.Index_No,
            'First Name': m.Full_Name,
            'Middle Name': m.Middle_name,
            'Last Name': m.Last_name,
            'Father Email': m.PAR_Father_Email,
            'Father Register': m.FatherRegister,
            'Father Invite Email Send': m.FatherEmailSent,
            'Mother Email': m.PAR_Mother_Email,
            'Mother Register': m.MotherRegister,
            'Mother Invite Email Send': m.MotherEmailSent,
          }

          dsFinal.push(temp)
        })

        var sheet1WS = XLSX.utils.json_to_sheet(dsFinal)
        var wb = XLSX.utils.book_new() // make Workbook of Excel
        XLSX.utils.book_append_sheet(wb, sheet1WS, 'sheet1') // sheetAName is name of Worksheet
        XLSX.writeFile(wb, 'Parent Register Status Report.xlsx') // name of the file is 'book.xlsx'
      }
    },
  },
}
</script>

<style scoped>
.btnExport {
  display: block;
}
</style>
